import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../../lib/adminAuth";

/**
 * Wrap any admin route. If no admin token, redirect to /admin (login).
 * While the auth check is in flight, render a thin loader.
 */
export default function RequireAdmin({ children }) {
  const { admin } = useAdminAuth();
  if (admin === null) {
    return (
      <div
        data-testid="admin-loading"
        className="flex min-h-screen items-center justify-center bg-[#fdf8f3] text-stone-500"
      >
        Checking session…
      </div>
    );
  }
  if (admin === false) return <Navigate to="/admin" replace />;
  return children;
}
